const NOTES_ROUTE = '/notepad'
const NOTES_ROUTE_LIST = '/notepad/list'

export { NOTES_ROUTE, NOTES_ROUTE_LIST }
